document.addEventListener("DOMContentLoaded", function () {
  const toggleTitles = document.querySelectorAll(".app_toggle_tit");

  toggleTitles.forEach(titleEl => {
    titleEl.addEventListener("click", function () {              
      const content = this.nextElementSibling; 

      this.classList.toggle("active");
      content.classList.toggle("active");  
    });
  });

  const deviceWrap = document.querySelector(".device_fixed_wrap");
  const headerWrap = document.querySelector(".header-wrapper");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 0) {
      deviceWrap.classList.add("active");
      headerWrap.classList.add("active");
    } else {
      deviceWrap.classList.remove("active");
      headerWrap.classList.add("active");
    }
  });
  
});

$(function() {
  var topDesc = $('.sub-desc-wrap .toggle_box');
     topDesc.addClass('collapsed');
     topDesc.find('.hide').hide();
     topDesc.eq(0).removeClass('collapsed');
     topDesc.eq(0).find('.hide').show();

     $('.sub-desc-wrap .toggle_box > .title').click(function(){
         var firstDesc = $(this).parents('.sub-desc-wrap .toggle_box:first');
         if(firstDesc.hasClass('collapsed')){
             topDesc.addClass('collapsed').removeClass('show');
             topDesc.find('.hide').slideUp(100);
             firstDesc.removeClass('collapsed').addClass('show');
             firstDesc.find('.hide').slideDown(100);
         } else {
             firstDesc.removeClass('show').addClass('collapsed');
             firstDesc.find('.hide').slideUp(100);
         }
         return false;
     });



    var bottomDesc = $('.dis_wrap .toggle_box');
    var bottomDesc2 = $('.dis_wrap .toggle_box2');
    var bottomDesc3 = $('.dis_wrap.device .toggle_box');
     bottomDesc.addClass('collapsed');
     bottomDesc.find('.hide').hide();
     bottomDesc.eq(0).removeClass('collapsed');
     bottomDesc3.eq(0).addClass('collapsed');
     bottomDesc.eq(0).find('.hide').show();
    bottomDesc3.eq(0).find('.hide').hide();

     bottomDesc2.find('.hide').hide();
     bottomDesc2.addClass('collapsed');
     bottomDesc2.eq(0).removeClass('collapsed');
     bottomDesc2.eq(0).find('.hide:first').show();
    
    if($(window).width() < 768) {
      bottomDesc.eq(0).find('.hide').hide();
      bottomDesc.eq(0).addClass('collapsed');
      $('.dis_wrap .toggle_box .title').click(function(){
           var firstDesc = $(this).parents('.dis_wrap .toggle_box:first');
             if(firstDesc.hasClass('collapsed')){
               bottomDesc.addClass('collapsed').removeClass('show');
               bottomDesc.find('.hide').slideUp(100);
               firstDesc.removeClass('collapsed').addClass('show');
               firstDesc.find('.hide').slideDown(100);
           } else {
               firstDesc.removeClass('show').addClass('collapsed');
               firstDesc.find('.hide').slideUp(100);
           }
           return false;
        
       });
    } else {
       $('.dis_wrap .toggle_box .title').click(function(){
           var firstDesc = $(this).parents('.dis_wrap .toggle_box:first');
           if(firstDesc.hasClass('collapsed')){
               bottomDesc.addClass('collapsed').removeClass('show');
               bottomDesc.find('.hide').slideUp(100);
               firstDesc.removeClass('collapsed').addClass('show');
               firstDesc.find('.hide').slideDown(100);
           } else {
               firstDesc.removeClass('show').addClass('collapsed');
               firstDesc.find('.hide').slideUp(100);
           }
           return false;
       });
    }


    if($(window).width() < 768) {
      bottomDesc2.eq(0).find('.hide').hide();
      bottomDesc2.eq(0).addClass('collapsed');
      $('.dis_wrap .toggle_box2 .title').click(function(){
           var firstDesc = $(this).parents('.dis_wrap .toggle_box2:first');
             if(firstDesc.hasClass('collapsed')){
               bottomDesc.addClass('collapsed').removeClass('show');
               bottomDesc.find('.hide').slideUp(100);
               firstDesc.removeClass('collapsed').addClass('show');
               firstDesc.find('.hide').slideDown(100);
           } else {
               firstDesc.removeClass('show').addClass('collapsed');
               firstDesc.find('.hide').slideUp(100);
           }
           return false;
        
       });
    } else {
       $('.dis_wrap .toggle_box2 .title').click(function(){
           var firstDesc = $(this).parents('.dis_wrap .toggle_box2:first');
           if(firstDesc.hasClass('collapsed')){
               bottomDesc.addClass('collapsed').removeClass('show');
               bottomDesc.find('.hide').slideUp(100);
               firstDesc.removeClass('collapsed').addClass('show');
               firstDesc.find('.hide').slideDown(100);
           } else {
               firstDesc.removeClass('show').addClass('collapsed');
               firstDesc.find('.hide').slideUp(100);
           }
           return false;
       });
    }

      // Frequently Asked Question
     var article = $('.faq>.faqBody>.article');
     article.addClass('t_hide');
     article.find('.a').hide();
     article.eq(0).removeClass('t_hide');
     article.eq(0).find('.a').show();
     $('.faq>.faqBody>.article>.q>a').click(function(){
         var myArticle = $(this).parents('.article:first');
         if(myArticle.hasClass('t_hide')){
             article.addClass('t_hide').removeClass('show');
             article.find('.a').slideUp(100);
             myArticle.removeClass('t_hide').addClass('show');
             myArticle.find('.a').slideDown(100);
         } else {
             myArticle.removeClass('show').addClass('t_hide');
             myArticle.find('.a').slideUp(100);
         }
         return false;
     });

     var shortsSlide = new Swiper('.shorts-slide', {
            slidesPerView: 1.8, 
            spaceBetween: 10, 
            pagination: {
                el: ".short-pagination",
                type: "progressbar",
              },
            breakpoints: { 
             
              768: {
               
              },
              1024: {
                slidesPerView: 1.8,
              },
            }
      });
  
     var bodySlide = new Swiper('.body-slide', {
         slidesPerView: 1.2, 

       spaceBetween: 10, 
         pagination: {
             el: ".body-pagination",
             type: "progressbar",
           },
       observer: true,
      observeParents: true,
         breakpoints: { 
         
          
           1024: {
             slidesPerView: 2.3,
             spaceBetween: 20, 
           },
         }
   });

   var vitaSlide = new Swiper('.vita-slide', {
         slidesPerView: 1.2, 
         spaceBetween: 10, 
         autoHeight: true,
     
         breakpoints: { 
         
          1024: {
             slidesPerView: 1.5,
             spaceBetween: 20, 
           },
           
         }
   });

    var vitaSlide = new Swiper('.vita-slide2', {
            slidesPerView: 2.5, 
            spaceBetween: 10, 
            autoHeight: true,
        
            breakpoints: { 
            
             1024: {
                slidesPerView: 3.5,
                spaceBetween: 20, 
              },
              
            }
      });

      var vitaSlide = new Swiper('.vita-slide3', {
            slidesPerView: 2.5, 
            spaceBetween: 10, 
            autoHeight: true,
        
            breakpoints: { 
            
             1024: {
                slidesPerView: 3.5,
                spaceBetween: 20, 
              },
              
            }
      });

  var detailLogo1 = new Swiper('.detail_logo1', {
    slidesPerView: 2, 
    loop:true,
    speed:3000,
    autoplay:{
        delay : 0,
        disableOnInteraction : false,
    },
    allowTouchMove: true,
  breakpoints: { 

      769: {
       slidesPerView: 'auto', 
      },    
    }

});

  var detailLogo2 = new Swiper('.detail_logo2', {
    slidesPerView: 'auto', 
     centeredSlides: true,
   loop:true,
    autoplay:{
        delay : 2500,
        disableOnInteraction : false,
    },
    allowTouchMove: true,
    pagination: {
        el: ".logo-page",
        clickable: true,
      },
      navigation: {
        nextEl: ".logo-next",
        prevEl: ".logo-prev",
      },
    
  breakpoints: { 

      769: {
       slidesPerView: 'auto', 
      },    
    }

});

var deviceSlide = new Swiper('.device_slide', {
            slidesPerView: 'auto', 
            spaceBetween: 20, 
            slidesOffsetAfter:50,
               pagination: {
              el: ".device-page",
              clickable: true,
            },
            breakpoints: { 
            
             769: {
                slidesPerView: 4,
                spaceBetween: 25, 
                 slidesOffsetAfter:0,
              },
              
            }
      });
var motionSlide = new Swiper('.mode_slide', {
            slidesPerView: 1.2, 
            spaceBetween: 20, 
            slidesOffsetAfter:50,
        
            breakpoints: { 
            
             769: {
              slidesPerView: 'auto', 
                slidesPerView: 4,
       
                 slidesOffsetAfter:0,
              },
              
            }
      });
var motionSlide = new Swiper('.motion_slide', {
            slidesPerView: 1, 
            spaceBetween: 0,  
            loop:true,    
             pagination: {
              el: ".motion-page",
              clickable: true,
            },
            navigation: {
              nextEl: ".motion-next",
              prevEl: ".motion-prev",
            },
    
      });      
var bnaSlide = new Swiper('.bna_slide', {
              slidesPerView: 1.2, 
            spaceBetween: 20, 
            slidesOffsetAfter:30,
             
              pagination: {
              el: ".bna-page",
              clickable: true,
            },
            breakpoints: { 
            
             769: {
                slidesPerView: 4,
                spaceBetween: 15,
                slidesOffsetAfter:0,
              },
              
            }
    
      });

var comSlide = new Swiper('.comment_slide', {
            slidesPerView: 1, 
            spaceBetween: 0,     
            loop:true,  
             pagination: {
              el: ".com-page",
              clickable: true,
            },
            navigation: {
              nextEl: ".com-next",
              prevEl: ".com-prev",
            },
    
      });

var appSlide = new Swiper('.app_slide_inner', {
            slidesPerView: 1, 
            spaceBetween: 0,      
             pagination: {
              el: ".app-page",
              clickable: true,
            },
            navigation: {
              nextEl: ".app-next",
              prevEl: ".app-prev",
            },
            breakpoints: { 
            
             769: {
                slidesPerView: 4,
        
              },
              
            }
    
    
      });

 $(document).on('click', '.prd_plus', function() {
    var $gradient = $(this);
    var $target = $gradient.prev('.bna-slide-inner'); // 바로 이전 형제 요소 선택

    if ($target.length) {
      $target.toggleClass('open'); // open 클래스 토글
    }
  });


// Modal
var modals = document.getElementsByClassName("modal");
var btns = document.getElementsByClassName("modalBtn");
var spanes = document.getElementsByClassName("close");
var funcs = [];
 

function Modal(num) {
  return function() {
   
    btns[num].onclick =  function() {
        modals[num].style.display = "block";
        console.log(num);
    };

    spanes[num].onclick = function() {
        modals[num].style.display = "none";
    };
  };
}
 
for(var i = 0; i < btns.length; i++) {
  funcs[i] = Modal(i);
}
 
for(var j = 0; j < btns.length; j++) {
  funcs[j]();
}
 
window.onclick = function(event) {
  if (event.target.className == "modal") {
      event.target.style.display = "none";
  }
};

 });

function downloadPDF(pdfUrl) {
    fetch(pdfUrl)
        .then(response => response.blob()) 
        .then(blob => {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = pdfUrl.split('/').pop().split('?')[0];
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href); 
        })
        .catch(error => console.error("PDF 다운로드 오류:", error));
}



// PDF 다운로드 피씨
      document.querySelectorAll(".downloadLink").forEach(link => {
    link.addEventListener("click", function(event) {
        event.preventDefault(); // 기본 동작 방지

        const fileUrl = this.getAttribute("data-pdf"); 
        const fileName = fileUrl.split("/").pop().split("?")[0];

        fetch(fileUrl)
            .then(response => response.blob()) 
            .then(blob => {
                const downloadLink = document.createElement("a");
                downloadLink.href = URL.createObjectURL(blob);
                downloadLink.download = fileName;
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            })
            .catch(error => console.error("파일 다운로드 오류:", error));
    });
});